// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CaseSessionModel } from './caseSessionModel.js';
import type { SurveySessionValueReadModel } from './surveySessionValueReadModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PatientAccountGetCaseGetCaseSurveyResponseModel {
    'sessionData': CaseSessionModel | null;
    'valueData': Array<SurveySessionValueReadModel>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PatientAccountGetCaseGetCaseSurveyResponseModel>> = [
        {
            "name":     "sessionData",
            "baseName": "sessionData",
            "type":     "CaseSessionModel"
        },
        {
            "name":     "valueData",
            "baseName": "valueData",
            "type":     "Array<SurveySessionValueReadModel>"
        },
    ];

    static getAttributeTypeMap() {
        return PatientAccountGetCaseGetCaseSurveyResponseModel.attributeTypeMap;
    }
}
